import styled from "styled-components";

export const TermsContainer = styled.div`
  margin: 2%;
  .terms-box {
    box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 8px;
  }
`;

export const Terms = styled.div`
  max-height: ${({ height }) => height};
  overflow-y: auto;
  background: #f5f5f5;
  padding: 15px;
  -webkit-mask-image: linear-gradient(180deg, #000 90%, transparent);
  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background: #92929e;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #495057;
  }
`;

export const LoadingScreen = styled.div`
  height: 350px;
  margin: 6%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SwalListStyle = `
  text-align: left; 
  list-style-type: disc; 
  padding-left: 20px;
`;
